import { notifications } from '@mantine/notifications';
import { refreshDataSet } from '../../apiClient';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useRefreshDataSet = () => {
    const entityUpdater = useEntityQueryUpdate();
    const mutation = useMutation({
        mutationKey: 'refresh_dataset',
        mutationFn: (model) => refreshDataSet(model),
        onSuccess: (data) => {
            entityUpdater([['data_sets'], ['data_set', data.id]], data);
            notifications.show({
                title: 'Success',
                message: 'Successfully refreshed data set.',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useRefreshDataSet;
